import { render, staticRenderFns } from "./Shipper.vue?vue&type=template&id=ca6aa880"
import script from "./Shipper.vue?vue&type=script&lang=js"
export * from "./Shipper.vue?vue&type=script&lang=js"
import style0 from "./Shipper.vue?vue&type=style&index=0&id=ca6aa880&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports